import InvestStrategyPageNew from './InvestStrategyPageNew';

export default InvestStrategyPageNew;
